// 清空对象的空值
const _getClearNullData = (params) => {
  try {
    if(Object.prototype.toString(params) !== '[object Object]') return params
    let newParams={}
    for(var k in params) (params[k]!== '' && params[k]!== null && params[k] !== undefined) && (newParams[k] = params[k])
    return newParams
  } catch (e) {
    console.log(e)
    return params
  }
} 

export {
    _getClearNullData
}
